<template>
    <div class="main">
        <div class="body-content">
            <h1>Upload Entry</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="partyname">Party *</label>
                    <v-select :clearable="false" tabindex="0" placeholder="Select Party Name" id="partyname"
                        v-model="newContainer.partyName" :options="party" label="short_name"
                        :reduce="party => party.autoid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vcnname">VCN No *</label>
                    <v-select :clearable="false" id="vcnname" v-model="newContainer.vcnID" :options="vcns"
                        @v-on:change="FillVCNDetails" label="vcnName" :reduce="vcn => vcn.vcnID" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="vesselName">Vessel *</label>
                    <v-select :clearable="false" id="vesselName" placeholder="Select Vessel"
                        v-model="newContainer.vesselID" ref="vesselName" :options="vessel" label="Name"
                        :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
                </div>

                <div class="form-item">
                    <label for="voyageName">Voyage *</label>
                    <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage"
                        label="Name" :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="location">Location:</label>
                    <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location"
                        label="Name" :reduce="location => location.locationid" selectOnTab="True" />
                </div>
                <div class="form-item">
                    <label for="port">Transhipment:</label>
                    <v-select id="port" :clearable="false" v-model="newContainer.pod" :options="ports" label="PortCode"
                        :reduce="port => port.portid" placeholder="Select POD" selectOnTab="True" />
                </div>
            </div>
            <div class="form-group">
                <div class="form-item">
                    <label for="fileAdd">File:</label>
                    <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
                </div>
                <div class="form-item">
                    <label>
                        Is Rail?
                        <input type="checkbox" v-model="newContainer.israil" name="israil" value="true">
                    </label>
                    <label>
                        Is SOC?
                        <input type="checkbox" v-model="newContainer.is_soc" name="is_soc" value="true">
                    </label>
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Convert</button>
                </div>
            </div>
            <hr />
            <div class="table-container">
                <table class="transaction-table table-design">
                    <thead>
                        <tr>
                            <th>
                                <span>Sl. No</span>
                            </th>
                            <th>
                                <span>File Name</span>
                            </th>
                            <th>
                                <span>No or Container</span>
                            </th>
                            <th>
                                <span>Status</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="ld in fetchedList" :key="ld[0]" class="successful-task">
                            <td></td>
                            <td>{{ ld[0] }}</td>
                            <th>
                                <span>{{ ld[1] }}</span>
                            </th>
                            <th>
                                <span>{{ ld[2] }}</span>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <hr />
            <h1>Generate PDF</h1>
            <div class="form-group">
                <div class="form-item">
                    <label for="oldcoprarno">Old Coprar No *</label>
                    <input id="oldcoprarno" class="field-p-100" v-model="oldcoprarno" />
                </div>
                <div class="form-item">
                    <label for="newcoprarno">New Coprar No *</label>
                    <input id="newcoprarno" class="field-p-100" v-model="newcoprarno" />
                </div>
                <div class="form-item">
                    <label for="filetype">File Type *</label>
                    <select id="filetype" class="field-p-100" v-model="filetype">
                        <option value="1">PDF</option>
                        <option value="2">Excel</option>
                    </select>
                </div>
                <div class="form-item">
                    <button type="button" class="excel-button" @click="generatepdf" :disabled="isSubmitting">Generate</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import { saveAs } from 'file-saver';
import * as cs from '../assets/js/commonscript.js'

export default {
    components: {
        VSelect,
    },
    data() {
        return {
            transactions: [],
            party: JSON.parse(localStorage.getItem('party')),
            vessel: JSON.parse(localStorage.getItem('vessel')) || [],
            voyage: JSON.parse(localStorage.getItem('voyage')) || [],
            location: JSON.parse(localStorage.getItem('Area')) || [],
            ports: JSON.parse(localStorage.getItem('ports')) || [],
            vcns: [],
            uploadlist: [],
            oldcoprarno: "",
            newcoprarno: "",
            filetype: 1, // 1 for PDF, 2 for Excel
            isSubmitting: false,
            newContainer: {
                partyName: 0,
                applicantID: 0,
                accountID: 0,
                vesselID: 0,
                vesselname: '',
                consign: '',
                vcnID: 0,
                VoyId: 0,
                voyage: '',
                pod: 128,
                podcode: '',
                locID: 0,
                israil: false,
                is_soc: false,
                file: null,
            },
            htmlContent: null,
        }
    },
    created() {
        this.fetchVcnList();
    },
    computed: {
        fetchedList() {
            //console.log(this.successfulTasks);
            //console.log(this.uploadlist);
            return this.uploadlist;
        },
    },
    watch: {
        'newContainer.vcnID'(value) {
            this.FillVCNDetails(value)
        }
    },
    methods: {
        async fetchVcnList() {
            const token = localStorage.getItem('access_token');
            try {
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                };
                const response = await axios.get('/active_vcn_list/', config);
                var data = response.data[2]
                data.push({ "vcnID": 0, "vcnName": "Select VCN", "vesselID": 0, "import_voyage": 0, "export_voyage": 0, "MlocID": 0, "ImpRotNo": "", "ImpRotDate": null, "ExpRotNo": "", "ExpRotDate": null, "BerthDate": null, "EgmDate": null, "SailDate": null, "IsSail": 0, "vesselLocation": 0, "created_by": 0, "CreateDate": null, "last_modified_by": 0, "ModiDate": null, "VesselName": "", "import_voyageName": "", "export_voyageName": "", "area": "", "Vesselarea": "" })
                this.vcns = data;
            } catch (error) {
                console.error('Error fetching VCN list:', error);
                useToast().error(error.response?.data?.message || 'Error fetching VCN list.');
            }
        },
        FillVCNDetails(value) {
            //const vcnID = this.newContainer.vcnID
            const selvcn = this.vcns.find(vcn => vcn.vcnID === value);
            if (selvcn.vcnID !== 0) {
                if (selvcn) {
                    this.newContainer.vesselID = selvcn.vesselID
                    this.newContainer.VoyId = selvcn.export_voyage
                    this.newContainer.voyage = selvcn.export_voyageName
                    this.newContainer.locID = selvcn.MlocID
                }
            }
        },
        updateApplicantAccountIds(value) {
            const AppAcc = cs.GetAppAccFromParty(value)
            this.newContainer.applicantID = AppAcc.applicantid
            this.newContainer.accountID = AppAcc.accountid
        },
        handleFileUpload(event) {
            this.newContainer.file = event.target.files[0];
        },
        async uploadFiles() {
            if (this.isSubmitting) return;
            
            this.uploadlist = [];
            this.updateApplicantAccountIds(this.newContainer.partyName)

            if (this.newContainer.applicantID == 0) {
                useToast().error("Select party");
                return;
            }
            const selvcn = this.vcns.find(vcn => vcn.vcnID === this.newContainer.vcnID);
            //console.log(selvcn)
            if (selvcn.vcnID !== 0) {
                if (selvcn) {
                    this.newContainer.vesselID = selvcn.vesselID
                    this.newContainer.VoyId = selvcn.export_voyage
                    this.newContainer.voyage = selvcn.export_voyageName
                    this.newContainer.locID = selvcn.MlocID
                }
            } else {
                useToast().error("Select VCN");
                return;
            }
            const selvessel = this.vessel.find(vessel => vessel.Vesselid === this.newContainer.vesselID);
            if (selvessel.Vesselid !== 0) {
                if (selvessel) {
                    this.newContainer.consign = selvessel.txtColsign
                    this.newContainer.vesselname = selvessel.Name
                }
            } else {
                useToast().error("Select vessel");
                return;
            }
            const selport = this.ports.find(port => port.portid === this.newContainer.pod);
            if (selport.portid !== 0) {
                if (selport) {
                    this.newContainer.podcode = selport.PortCode
                }
            } else {
                useToast().error("Select Transipment Port");
                return;
            }

            if (this.newContainer.locID == 0) {
                useToast().error("Select location");
                return;
            }
            if (this.newContainer.file == null) {
                useToast().error("Select file");
                return;
            }
            if (this.newContainer.consign == null) {
                useToast().error("Vessel colsign not entered");
                return;
            }

            this.isSubmitting = true;
            
            try {
                //console.log(this.newContainer);
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                };
                const data = new FormData();
                data.append('file', this.newContainer.file);
                const response = await axios.post('/convert_cartin?applicant=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID + '&vesselid=' + this.newContainer.vesselID + '&voyageid=' + this.newContainer.VoyId + '&loc=' + this.newContainer.locID + '&consign=' + this.newContainer.consign + '&vesselname=' + this.newContainer.vesselname + '&voyage=' + this.newContainer.voyage + '&transhipment=' + this.newContainer.podcode.trim() + '&pod=' + this.newContainer.pod+'&israil='+this.newContainer.israil+'&is_soc='+this.newContainer.is_soc, data, config);
                //console.log(response)
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    this.uploadlist = response.data[2]
                    if (response.data[3] != '') {
                        useToast().success("File Downloaded");
                        this.downloadcoprar(response.data[3])
                    }else{                    
                        useToast().error("File has errors");
                    }
                }
            } catch (error) {
                console.error('Error uploading file:', error);
                useToast().error(error.response?.data?.message || 'Error converting file.');
            } finally {
                this.isSubmitting = false;
            }
        },
        async downloadcoprar(filename) {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    responseType: 'blob'
                };
                const urlpath = `/download_coprar_txt?filenm=${filename}`;
                //console.log(urlpath)
                const response = await axios.post(urlpath, config);
                const blob = new Blob([response.data], { type: 'application/octet-stream' });
                saveAs(blob, filename);
            } catch (error) {
                console.error('Error downloading file:', error);
                useToast().error(error.response?.data?.message || 'Error downloading file.');
            }
        },
        async generatepdf() {
            if (this.isSubmitting) return;
            
            if (!this.oldcoprarno.trim()) {
                useToast().error('Old Coprar No is required.');
                return;
            }
            if (!this.newcoprarno.trim()) {
                useToast().error('New Coprar No is required.');
                return;
            }
            if (this.newContainer.partyName == 0) {
                useToast().error('Please select a party.');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                //console.log(this.oldcoprarno)
                const token = localStorage.getItem('access_token');
                if (!token) {
                    useToast().error('Authentication token not found.');
                    return;
                }
                
                const config = {
                    headers: {
                        'accept': 'application/json',
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'multipart/form-data'
                    },
                };
                this.updateApplicantAccountIds(this.newContainer.partyName)
                
                const response = await axios.post('/convert_cartin_pdf?coprarno=' + this.oldcoprarno + '&newcoprarno=' + this.newcoprarno + '&applicant=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID+'&filetype='+this.filetype, config, { responseType: 'blob' });
                //console.log(response)
                
                if (response.data[0] === 0) {
                    useToast().error(response.data[1]);
                } else {
                    if (response.data['type'] == 'application/zip') {
                        useToast().success("File Downloaded");
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        saveAs(blob);
                    } else if (response.data['type'] == 'application/pdf') {
                        useToast().success("File Downloaded");
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        saveAs(blob);
                    }else if (response.data['type'] == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                        useToast().success("File Downloaded");
                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        saveAs(blob);
                    } else {
                        useToast().error("File has errors");
                    }
                }
            } catch (error) {
                console.error('Error generating PDF:', error);
                useToast().error(error.response?.data?.message || 'Error generating PDF.');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}

</script>
<style scoped>
.table-container {
    /*max-height: 100%;*/
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 10px;
}

.transaction-table {
    width: 100%;
    height: 100%;
    border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
}

.transaction-table th {
    background-color: #f2f2f2;
    font-weight: bold;
}

.transaction-table th .filter-icon {
    cursor: pointer;
    margin-left: 5px;
}

/* Form group styling for form elements */
.field-p-100 {
    width: 100%;
}

.form-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-bottom: 5px;
}

.form-item {
    width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 14px;
    background-color: #FFF;
}

.excel-button {
    background-color: #17a2b8;
    color: white;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    margin-right: 10px;
}

.excel-button:disabled {
    background-color: #6c757d;
    cursor: not-allowed;
    opacity: 0.6;
}
</style>